import React, { useState } from "react";
import PageHeader from "../components/PageHeader";
import Button from "../components/Button";

export default function FavoritesTab({ store, onJumpTo }) {
  const lines = Object.values(store.lines || {});
  const [q, setQ] = useState("");
  const [tag, setTag] = useState("");

  const tags = [...new Set(lines.flatMap((l) => l.tags || []))].sort();
  const filtered = lines
    .filter(
      (l) =>
        !q ||
        l.snippet.toLowerCase().includes(q.toLowerCase()) ||
        (l.why || "").toLowerCase().includes(q.toLowerCase()) ||
        l.songTitle.toLowerCase().includes(q.toLowerCase()) ||
        l.albumTitle.toLowerCase().includes(q.toLowerCase())
    )
    .filter((l) => !tag || (l.tags || []).includes(tag))
    .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));

  return (
    <>
      <PageHeader
        title="Favorites — All Lines"
        description="All saved lines across every album. Filter, then jump back to the song workspace."
      >
        <div className="toolbar">
          <label>
            Search
            <input
              className="input"
              type="search"
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder="line, why, song, album"
              aria-label="Search favorites"
            />
          </label>
          <label>
            Tag
            <select
              className="input"
              value={tag}
              onChange={(e) => setTag(e.target.value)}
              aria-label="Filter by tag"
            >
              <option value="">All</option>
              {tags.map((t) => (
                <option key={t} value={t}>
                  {t}
                </option>
              ))}
            </select>
          </label>
          <Button className="secondary" onClick={() => window.print()}>
            Print
          </Button>
        </div>
      </PageHeader>

      <div
        className="grid"
        style={{
          gridTemplateColumns: "repeat(auto-fit,minmax(280px,1fr))",
          gap: 12,
        }}
      >
        {filtered.map((l, idx) => (
          <article
            key={l.id}
            className="scribble"
            style={{ "--rot": idx % 2 ? "-0.4deg" : "0.4deg" }}
          >
            <header className="xs muted">
              {new Date(l.createdAt).toLocaleString()}
            </header>
            <h3 className="sm" style={{ margin: "6px 0 4px 0" }}>
              {l.songTitle}
            </h3>
            <div className="xs muted">{l.albumTitle}</div>
            <blockquote
              className="sm"
              style={{ marginTop: 8, fontStyle: "italic" }}
            >
              &ldquo;{l.snippet}&rdquo;
            </blockquote>
            {l.why && (
              <p className="sm" style={{ marginTop: 8 }}>
                {l.why}
              </p>
            )}
            <div
              style={{
                display: "flex",
                gap: 6,
                flexWrap: "wrap",
                marginTop: 8,
              }}
            >
              {(l.tags || []).map((t) => (
                <span className="pill" key={t}>
                  {t}
                </span>
              ))}
            </div>
            <div style={{ textAlign: "right", marginTop: 8 }}>
              <Button
                className="ghost"
                onClick={() => onJumpTo(l.albumId, l.songId)}
              >
                Open song
              </Button>
            </div>
          </article>
        ))}
        {!filtered.length && (
          <section className="card paper">
            <div className="sm muted">No saved lines yet.</div>
          </section>
        )}
      </div>
    </>
  );
}
